import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// ASSET SALE RECEIPT APIs
// Legacy route: /Purchase/AssetSaleReceipt
// ==============================================

// 1. Get Request Numbers eligible for receipt (GET)
export const getRequestItems = async ({ uid, rid }) => {
    try {
        const queryParams = new URLSearchParams({ UID: uid, RID: rid });
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/RequestItems?${queryParams}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get the item grid for a Request No (GET)
export const getAssetSaleItemRecDetails = async (reqno) => {
    try {
        const queryParams = new URLSearchParams({ Reqno: reqno });
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/GetAssetSaleItemRecDetails?${queryParams}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Get the buyer/party details + balance for a Request No (GET)
export const getAssetPartyDetails = async (reqno) => {
    try {
        const queryParams = new URLSearchParams({ Reqno: reqno });
        const response = await axios.get(
            `${API_BASE_URL}/Purchase/Getassetpartydetails?${queryParams}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 4. Save the Asset Sale Receipt (POST)
export const saveAssetSaleReceiptData = async (params) => {
    try {
        const payload = {
            Rid: params.rid,
            FromBank: params.fromBank,
            ModeofPay: params.modeOfPay,
            Amount: params.amount,
            BankRemarks: params.bankRemarks,
            UserRemarks: params.userRemarks,
            PaymentDate: params.paymentDate,
            No: params.no,
            RoleID: params.roleId,
            Createdby: params.createdBy,
        };

        const response = await axios.post(
            `${API_BASE_URL}/Purchase/SaveAssetSaleRecieptData`,
            payload,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 5. Get Bank Details for the "From Bank" dropdown (GET)
export const getBankDetails = async () => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetBankDetails`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};
